import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";
import { DfpAd } from "../dfp-ad";

const AdUnit = props => {
  return (
    <div className={styles["header-ad-unit"]}>
      <DfpAd adtype="Leaderboard" placement={props.placement} />
    </div>
  );
};

AdUnit.propTypes = {
  placement: PropTypes.string
};

export default AdUnit;
